import { useState } from 'react'
import { Modal } from './Modal'

interface ConfirmDangerProps {
  open: boolean
  title: string
  actionName: string
  description: string
  onConfirm: () => Promise<void> | void
  onClose: () => void
}

export function ConfirmDangerModal({
  open,
  title,
  actionName,
  description,
  onConfirm,
  onClose,
}: ConfirmDangerProps) {
  const [typed, setTyped] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleConfirm() {
    if (typed !== actionName) return
    setBusy(true)
    setError(null)
    try {
      await onConfirm()
      setTyped('')
      onClose()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Falha na operação')
    } finally {
      setBusy(false)
    }
  }

  function handleClose() {
    setTyped('')
    setError(null)
    onClose()
  }

  return (
    <Modal
      open={open}
      title={title}
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={handleClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            disabled={typed !== actionName || busy}
            onClick={handleConfirm}
          >
            {busy ? 'Executando…' : 'Confirmar'}
          </button>
        </>
      }
    >
      <p>{description}</p>
      <p>
        Digite <strong>{actionName}</strong> para confirmar:
      </p>
      <div className="field">
        <input
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          placeholder={actionName}
          autoComplete="off"
        />
      </div>
      {error && <div className="alert alert-error">{error}</div>}
    </Modal>
  )
}
